// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_GetStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/menu_itens/get_status.
 *
 * Returns the list of menu item status options (id + title) used to populate
 * the status select on the menu-items config screen.
 */
import type { MenuItens_GetStatusRow } from './MenuItens_GetStatusRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MenuItens_GetStatusResponseDados = MenuItens_GetStatusRow[];

export type MenuItens_GetStatusResponse = ApiResponse<MenuItens_GetStatusResponseDados>;

registerResponseContract('MenuItens_GetStatusResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      menu_item_status_id:     { type: 'number',  required: true },
      menu_item_status_titulo: { type: 'string',  required: true },
    },
  },
})
